import { AutoLink, type AutoLinkProps } from '@betterment/js-runtime';
import { Link, type LinkProps } from '@betterment/samba-react';

export type SambaAutoLinkProps = AutoLinkProps & LinkProps;

export const SambaAutoLink: React.FC<SambaAutoLinkProps> = ({
  to,
  children,
  prefetch,
  preventScrollReset,
  reloadDocument,
  viewTransition,
  ...linkProps
}) => {
  const reactRouterProps = { prefetch, preventScrollReset, reloadDocument, viewTransition };
  return (
    <Link asChild={true} {...linkProps}>
      <AutoLink to={to} {...reactRouterProps}>
        {children}
      </AutoLink>
    </Link>
  );
};
